import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../../constants";

/** 인스턴스별 추출 데이터 */
export const extractSchema = {
    "documentInstanceExtract": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "dataDomainId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "dataDomain": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentExtractDataDomain",
            value: null,
        },
        "dataKey": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "dataValue": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "fieldId": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "fieldType": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "fieldName": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "fieldText": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "documentInstanceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
    }
} as const;
